// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 179 ? "main" : chunkId) + "." + {"4":"cad20de1","179":"f16effe7"}[chunkId] + ".css";
};